/*
 * Copyright (c) 2019 LNBIG.com
 * All rights reserved.
 */

import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import IconSatoshi from '../components/IconSatoshi'
import Telegram from 'simple-icons/icons/telegram'
import WhatsApp from 'simple-icons/icons/whatsapp'

Vue.use(Vuetify)

console.log("Telegram path is: %s", Telegram.path)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    values: {
      satoshi: {
        component: IconSatoshi,
      },
      telegram: Telegram.path,
      whatsapp: WhatsApp.path,
    }
  },
})
